import { render } from "./PasswordWithCurrentEmail.vue?vue&type=template&id=0fdd12b9&scoped=true&ts=true"
import script from "./PasswordWithCurrentEmail.vue?vue&type=script&lang=ts"
export * from "./PasswordWithCurrentEmail.vue?vue&type=script&lang=ts"

import "./PasswordWithCurrentEmail.vue?vue&type=style&index=0&id=0fdd12b9&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\mobileApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fdd12b9"]])

export default __exports__